import * as THREE from 'three';
import { renderConfig } from '../config';
import type { CameraController } from './CameraController';

export class CameraRig {
  readonly camera: THREE.PerspectiveCamera;
  private controller: CameraController | null = null;

  constructor(aspect: number) {
    const { fov, near, far, initialPosition } = renderConfig.camera;
    this.camera = new THREE.PerspectiveCamera(fov, aspect, near, far);
    this.camera.position.set(
      initialPosition.x,
      initialPosition.y,
      initialPosition.z
    );
    this.camera.lookAt(0, 0, 0);
  }

  setAspect(aspect: number): void {
    this.camera.aspect = aspect;
    this.camera.updateProjectionMatrix();
  }

  setController(controller: CameraController | null): void {
    this.controller = controller;
  }

  update(dt: number): void {
    this.controller?.update(dt);
  }
}
